import { atom } from "recoil";
import atomKeys from "configs/atoms";
import moment from "moment";

export const dashboardCampaignSelectionAtom = atom({
    key: atomKeys.Statistic.DashboardCampaignSelection,
    default: 0,
});

export const dashboardSelectedMonthAtom = atom({
    key: atomKeys.Statistic.DashboardSelectedMonth,
    default: moment().startOf('month').format("YYYY/MM/DD"),
});
